export const title = 'Доступ к\u00A0камере и\u00A0микрофону';

export const grantAccess = 'Предоставить доступ';

export const camera = {
    granted: 'Доступ к\u00A0камере получен',
    notGranted: (
        <>
            Чтобы участники могли видеть вас,
            <br />
            предоставьте доступ к камере
        </>
    ),
};

export const microphone = {
    granted: 'Доступ к\u00A0микрофону получен',
    hint: {
        granted: 'Теперь вы\u00A0можете подключиться к\u00A0встрече',
        notGranted: 'Обязательно для подключения',
    },
    notGranted: (
        <>
            Предоставьте доступ к&nbsp;микрофону.
            <br />
            Без звука вас не&nbsp;услышат другие участники.
        </>
    ),
};

export const join = 'Подключиться';
